//@ts-ignore
export default function (state: any, action: { type: string; payload?: { currencies: string[] } }) {
    if (!state) {
        state = [];
    }
    switch (action.type) {
        case 'CURRENCIES_LOAD':
            return state;
        case 'CURRENCIES_LOAD_DONE':
            return action.payload;
        default:
            return state;
    }
}
